import {Component, Input, OnInit} from '@angular/core';

import {AuthService} from '../../auth/auth.service';

@Component({
  selector: 'app-site-lang',
  templateUrl: './site-lang.component.html',
  styleUrls: ['./site-lang.component.scss']
})

export class SiteLangComponent implements OnInit {
  public radioModel = 'fr';
  @Input() siteMenu = false;

  constructor(private authServ: AuthService) {
      this.radioModel = authServ.getUserLang();
  }

  ngOnInit() {
  }

  changeLang(lang:string){
      this.radioModel = lang;
      this.authServ.langSelectedChange(this.radioModel);
  }
}
